import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';

@Injectable()
export class AccountService {

    constructor(private http: VnptHttpService) { }

    changePassword(dto){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = dto;
        return this.http.post(Config.apiUrl + 'account/ChangePassword', JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/account/account.service.ts